import { AgendaDragDropContainer } from "./AgendaDragDropContainer";

export default AgendaDragDropContainer;
